import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const defaultColor = "#c8e6e6";

const body = document.querySelector("#jcore-body");
body.style.backgroundColor = defaultColor;

const coloredSections = gsap.utils.toArray("#main .has-background");

coloredSections.forEach((section, index) => {
  const color = window.getComputedStyle(section).backgroundColor;
  section.style.backgroundColor = "unset";

  ScrollTrigger.create({
    trigger: section,
    start: "200 bottom",
    end: "+=100%",
    onToggle: (self) => {
      // When the section is active, change the background color of the content container to the color of the section.
      if (self.isActive) {
        gsap.to("#jcore-body, #main.content-container", {
          backgroundColor: color,
          overwrite: "auto",
        });
      } else if (
        // When we leave the first or last section, change the background color of the content container to the default color.
        (index === 0 && self.direction < 0) ||
        (index === coloredSections.length - 1 && self.direction > 0)
      ) {
        gsap.to("#jcore-body, #main.content-container", {
          backgroundColor: defaultColor,
          overwrite: "auto",
        });
      }
    },
  });
});
